// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"5616":"7b8bcfd6","6514":"7b8bcfd6"}[chunkId] + ".chunk.css";
};